export enum AssetCategoryType {
  CANADIAN_EQUITIES = 'CANADIAN_EQUITIES',
  INTERNATIONAL_EQUITIES = 'INTERNATIONAL_EQUITIES',
  CANADIAN_FIXED_INCOME = 'CANADIAN_FIXED_INCOME',
  INTERNATIONAL_FIXED_INCOME = 'INTERNATIONAL_FIXED_INCOME',
  US_EQUITIES = 'US_EQUITIES',
  CASH = 'CASH',
  OTHER = 'OTHER',
  UNCLASSIFIED = 'UNCLASSIFIED'
}

export enum AssetCategoryGroupType {
  EQUITIES = 'EQUITIES',
  CASH_AND_FIXED_INCOME = 'CASH_AND_FIXED_INCOME'
}
